import Sidebar from '../../components/Common/Sidebar';
import {  ResellerList } from '../../components/_pages/Reseller/Reseller';

const Reseller = () => {
  return (
    <>
      <Sidebar />
      <ResellerList />
    </>
  );
};

export default Reseller;
